import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MedReviewService } from '../../services/med-review.service';
import { BehaviorSubject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Pv1DialogComponent } from '../pv1-dialog/pv1-dialog.component';
import { cloneDeep } from 'lodash-es';
import { take } from 'rxjs/operators';
import { loadBamboohealthCheck } from '../../actions/med-review.actions';
import { Store } from '@ngrx/store';
import { selectBamboohealthData } from '../../selectors/med-review.selectors';
@Component({
  selector: 'kt-med-review-board',
  templateUrl: './med-review-board.component.html',
  styleUrls: ['./med-review-board.component.scss'],
})
export class MedReviewBoardComponent implements OnInit, OnDestroy {
  private subscriptions: any[] = [];
  private medReviewId;
  data: any = {};
  loading$ = new BehaviorSubject(true);
  subLoading$ = new BehaviorSubject(true);
  hasMedReviewSub = new BehaviorSubject(true);
  x = false;
  @Input() extMedReviewId = 0;
  @Input() readonly = false;
  patientId;
  @Input() fromPatient;
  @Input() patient_id_for_task_list;
  bambooHealthData$;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private medReviewService: MedReviewService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (this.fromPatient) this.patientId = this.patient_id_for_task_list || params.id;
      if (this.patientId && this.fromPatient) {
        this.medReviewService
          .getMedReviewByPatientId(this.patientId)
          .pipe(take(1))
          .subscribe((res: any) => {
            if (!res.data?.length) {
              this.loading$.next(false);
              this.subLoading$.next(false);
              this.hasMedReviewSub.next(false);
              return;
            }
            this.medReviewId = res.data[0].id;
            this.loadPatientMedReviewData();
          });
        return;
      }
      this.medReviewId = this.extMedReviewId || this.route.snapshot.params.id;
      this.loadPatientMedReviewData();
    });
    this.bambooHealthData$ = this.store.select(selectBamboohealthData);
  }

  private loadPatientMedReviewData() {
    this.data = null;
    this.processData();
    this.subLoading$.next(true);
    const patientMedSubscription = this.medReviewService
      .getPatientMedReview(this.medReviewId)
      .subscribe((res: any) => {
        this.medReviewService.currentMedReviewPatientId = res.patient_id;
        this.data = res;
        this.processData();
        this.loading$.next(false);
        this.subLoading$.next(false);
      });
    this.subscriptions.push(patientMedSubscription);
    this.loadBamboohealthData();
  }

  toggleViewMode() {
    const dataCloned = cloneDeep(this.data);
    const dialogRef = this.dialog.open(Pv1DialogComponent, {
      minWidth: '90vw',
      maxWidth: '100vw',
      width: '90vw',
      height: '600px',
      data: dataCloned,
      disableClose: true,
      closeOnNavigation: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.loadPatientMedReviewData();
    });
  }

  private loadBamboohealthData() {
    this.store.dispatch(
      loadBamboohealthCheck({ triggerType: 'MEDREVIEW_ENTRY', medReviewId: this.medReviewId }),
    );
  }
  private processData() {
    if (!this.data) {
      this.data = { medications: [] };
    }
    this.data.medications.forEach((e) => {
      if (!e.classification && e.med_review_id == this.data.id) {
        e.classification = 'DISCONTINUED';
      }
    });
    this.data.medications.forEach((e) => {
      const el = this.data.medications.find((d) => {
        return d.id != e.id && e.hicl == d.hicl;
      });
      if (el) {
        e.showRedBadge = true;
      }
    });

    this.data.medications.sort((a, b) => {
      const astr = a.drug || a.prescription?.drug?.drug || '';
      const bstr = b.drug || b.prescription?.drug?.drug || '';
      return astr.localeCompare(bstr);
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((el) => el.unsubscribe());
  }
}
